import { CircularProgress, Container, Divider, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, makeStyles } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getFeaturedCategories, getServices } from 'services/service.service';
import { mapCategoriesToServices } from '../2.2/ServicePackages/processor';
import ReactJson from 'react-json-view';
import { filterNonNull } from 'util/format';
import { useHistory, useLocation } from 'react-router-dom';
import { useCopyToClipboard } from 'usehooks-ts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faLink } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-hot-toast';
import { TestSelectGenerator } from './TestSelectGenerator';

const useStyles = makeStyles(theme => ({
  actions: {
    display: 'flex',
    flexDirection: 'column',
  }
}));
export const getServiceQueryParams = (service) => {
  const prefix = process.env.NODE_ENV === 'development' ? `${window.location.protocol}//${window.location.host}/createbooking?` : `${process.env.REACT_APP_SELF_LINK}/createbooking?`
  const serviceObject = filterNonNull({
    catid: service.id,
    typeid: service?.featured_service?.type_id,
    action: service?.action_type,
    services: service?.featured_service?.extended_package_item_ids,
    packages: service?.featured_service?.extended_package_ids,
  })
  const searchparams = new URLSearchParams(
    serviceObject
  ).toString()

  return `${prefix}${searchparams}`
}

const LinkGenerator = ({ }) => {
  const classes = useStyles()

  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);

  const [loading, setLoading] = useState(false);
  const [value, copy] = useCopyToClipboard()

  const history = useHistory()
  const fetchServices = useCallback(
    async () => {
      setLoading(true)
      const resServices = await getServices({
        latitude: 14.562909599624389,
        longitude: 121.03317570610837,
        // city: 1,
      })
      const resCategories = await getFeaturedCategories({
        latitude: 14.562909599624389,
        longitude: 121.03317570610837,
      })

      const mappedCategories = await mapCategoriesToServices(resCategories, resServices)
      setCategories(mappedCategories)
      setServices(resServices)
      setLoading(false)
    },
    [],
  );
  useEffect(
    () => {
      fetchServices()
    }, []
  );

  const getServiceQueryParams = useCallback(
    (service) => {
      const prefix = process.env.NODE_ENV === 'development' ? `${window.location.protocol}//${window.location.host}/createbooking?` : `${process.env.REACT_APP_SELF_LINK}/createbooking?`

      const searchparams = new URLSearchParams(
        {
          'item': service?.name
        }
      )

      return `${prefix}${searchparams}`
    },
    [],
  );

  if (loading) return <CircularProgress />
  return (
    <Container >
      {categories?.map(category => (
        <div key={category.id}>
          <h3>{category.name}</h3>
          <List dense>
            {category?.bookings?.map(service => {
              const link = getServiceQueryParams(service)
              return (
                <>
                  <ListItem key={service.id}>
                    <ListItemText primary={`${service.label} - (${service?.fillOptions?.canAddToCart ? 'Has Additional Options' : 'Standalone'})`}
                      secondary={link}
                    />
                    <ListItemSecondaryAction className={classes.actions}>
                      {/* <IconButton size="small" onClick={() => {
                        copy(link)
                        toast.success('Copied to clipboard')
                      }}>
                        <FontAwesomeIcon icon={faClipboard} />
                      </IconButton> */}
                      <IconButton size="small" onClick={() => window.open(link, '_blank')}>
                        <FontAwesomeIcon icon={faLink} />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                </>
              )
            })
            }
            {category?.bookings?.filter(s => s?.action_type === 'BOOK_SELECT_TESTS').map(service => {
              return <TestSelectGenerator catId={service?.id} service={service?.fillOptions?.prefill?.serviceCategory} />
            })
            }

          </List>
        </div>
      ))}
    </Container>
  )
  // return (
  //   <ReactJson src={{categories}} collapsed/>
  // )
}

export { LinkGenerator }